import {serialize} from 'object-to-formdata';

import {REST_METHODS} from '@/src/app/constants/api';
import authorizedFetch from '@/src/app/utils/authorizedFetch';

const reuploadStudentId = ({
  student_identificator,
  student_identificator_file,
}) => {
  const formData = serialize({
    student_identificator,
    student_identificator_file,
  });

  // @ts-ignore
  return authorizedFetch({
    method: REST_METHODS.PUT,
    path: `/api/v1/profiles/student_profiles`,
    formData,
  });
};

export default reuploadStudentId;
